import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";

/**
 * Reusable Affiliate Profile Dropdown Component
 * Used in affiliate header for both mobile and desktop
 * Features: User info, back to casino link
 */
const AffiliateProfileDropdown = ({
  isMobile = false,
  onClose,
  className = "",
}) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  // On mobile we want the dropdown to scroll away together with the affiliate navbar,
  // but keep the original full-width mobile styling. We anchor it to the header
  // (which is positioned) so it moves with the navbar instead of staying fixed
  // to the viewport.
  const baseClasses = isMobile
    ? "absolute left-0 right-0 top-full bg-card border-b border-border shadow-lg z-50"
    : "absolute right-0 mt-2 w-48 bg-card border border-border rounded-lg shadow-lg z-50";

  return (
    <div className={`${baseClasses} ${className}`}>
      <div className="py-1">
        {/* User Info Header */}
        <div className="px-4 py-2 border-b border-border">
          <div className="text-sm font-medium text-white">
            {user?.user_metadata?.first_name || "Affiliate"}
          </div>
          <div className="text-xs text-gray-400">{user?.email}</div>
          <div className="text-xs text-primary font-medium mt-1">
            Affiliate Partner
          </div>
        </div>

        {/* Back to Casino Button */}
        <button
          onClick={() => handleNavigation("/")}
          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-muted transition-colors cursor-pointer"
        >
          Back to Casino
        </button>
      </div>
    </div>
  );
};

export default AffiliateProfileDropdown;
